import React from 'react'
import NotesContainer from './Notes/NotesContainer'

export default function WorkFlowNotesSection({ event, notes, className }) {
  return (
    <NotesContainer defaultValue={notes} event={event} className={className} />
  )
}
